<h1 style="text-align: center;">{{nombreproyecto}}</h1>
<!-- Botón para agregar nuevo resultado -->
<div *ngIf="!crearRegistro && !editarRegistro" class="contenedor-boton">
    <button 
      pButton 
      type="button" 
      icon="pi pi-file-excel" 
      class="p-button-rounded boton-rosado" 
      pTooltip="Descargar Excel"
      tooltipPosition="top"
      (click)="descargarExcel()">
    </button>
  </div>


    <div >
        <span *ngFor="let form of formularios; let i = index" >

       
        Formulario {{i+1}}:
        <p-multiSelect 
        [options]="form.campos" 
        [(ngModel)]="form.camposdefecto"
        optionLabel="label"
        selectedItemsLabel="{0} columnasSeleccionadas"
        defaultLabel="Seleccionar columnas"
        > 
        </p-multiSelect> </span><button mat-raised-button (click)="filtrar()">Filtrar</button>
    </div>

    <!-- Boton filtrar -->
    


   <p-table #dt
        [value]="registros" 
        [tableStyle]="{ 'min-width': '50rem' }" 
        [rowHover]="true"
        [paginator]="true" 
        [globalFilterFields]="['Correo', 'Nombres']"
        [rows]="tampag"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,50,100,500]"
        [globalFilterFields]="columnas"
        filterDisplay="menu"
        scrollable="true" 
        scrollHeight="600px"
        >

         

    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let columna of columnas" >
                <span
                pSortableColumn="{{ columna }}"
                class="header-label">
                {{ columna }}
                <p-sortIcon [field]="columna"></p-sortIcon>
              </span>
                <p-columnFilter type="text"  field="{{columna}}" matchMode="contains" [showMenu]="false" >
                    
                </p-columnFilter>
            </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-registro>
        <tr (click)="navigateToRegistro(registro._id)" pSelectableRow>
            <td *ngFor="let columna of columnas">{{ registro[columna] }}</td>

        </tr>
    </ng-template>

    <ng-template pTemplate="summary">
        <div class="p-d-flex p-ai-center p-jc-between">
          Total Registros : {{total}}
        </div>
    </ng-template>

</p-table>


